import { NgModule } from '@angular/core';
import { BooleanToStringPipe } from '@shared/pipes/booleanToString.pipe';
import { SafeHtmlPipe } from '@shared/pipes/htmlSanitize.pipe';
import { CapitilizeFirstLetterPipe } from './capitilizeFirstLetter.pipe';
import { RemoveLineBreaksStringPipe } from './removeLineBreaksSring.pipe';
import { RemoveSpecialChars } from './removeSpecialCharsString.pipe';
import { ReplaceNullWithTextPipe } from './replaceNullWithText.pipe';
import { SplitPascalCaseStringPipe } from './splitPascalCaseString.pipe';
import { SplitStringByCharPipe } from './splitStringByChar.pipe';
import { ToUtcDatePipe } from './toUtcDate.pipe';

@NgModule({
    declarations: [
        SplitPascalCaseStringPipe,
        SplitStringByCharPipe,
        BooleanToStringPipe,
        SafeHtmlPipe,
        CapitilizeFirstLetterPipe,
        RemoveSpecialChars,
        RemoveLineBreaksStringPipe,
        ReplaceNullWithTextPipe,
        ToUtcDatePipe,
    ],
    imports: [],
    exports: [
        SplitPascalCaseStringPipe,
        SplitStringByCharPipe,
        BooleanToStringPipe,
        SafeHtmlPipe,
        CapitilizeFirstLetterPipe,
        RemoveSpecialChars,
        RemoveLineBreaksStringPipe,
        ReplaceNullWithTextPipe,
        ToUtcDatePipe,
    ],
})
export class PipesModule {}
